import { useQuery } from "@tanstack/react-query";
import { api } from "@/api/client";
import { queryKeys } from "@/lib/queryKeys";

export interface ToolCostItem {
  tool_name: string;
  unit: string;
  amount: number;
  cost_usd: number | null;
  event_count: number;
}

interface ToolCostListResponse {
  items: ToolCostItem[];
  count: number;
  total: number;
}

export interface ToolCostFilters {
  since?: string;
  until?: string;
}

export function useToolCost(
  projectSlug: string | null,
  filters: ToolCostFilters = {},
) {
  const query = useQuery({
    queryKey: queryKeys.metrics.toolCost(projectSlug, filters),
    queryFn: async () => {
      const params = new URLSearchParams();
      if (projectSlug) params.set("project", projectSlug);
      if (filters.since) params.set("since", filters.since);
      if (filters.until) params.set("until", filters.until);
      const qs = params.toString();
      const url = `/api/v1/telemetry/tool-cost${qs ? `?${qs}` : ""}`;
      const data = await api<ToolCostListResponse>(url);
      return data.items;
    },
  });

  return {
    items: query.data ?? [],
    loading: query.isLoading,
    error: query.error
      ? query.error instanceof Error
        ? query.error.message
        : "Failed to load tool cost data"
      : null,
  };
}
